import React from "react";
import { Link45deg } from 'react-bootstrap-icons';

const CalculadoraModalidades = (props) => {

    const [modalidades, setModalidades] = React.useState(['AC'])

    const handleChangeModalities = (modalidade, action) => {
        let newModalidades = [...modalidades]

        if (action) {
            newModalidades.push(modalidade)
        } else {
            newModalidades = newModalidades.filter(item => item !== modalidade)
        }

        let set = new Set(newModalidades);
        let newModalidadesSemDuplicados = Array.from(set);

        if (newModalidadesSemDuplicados.includes('EP')) {
            newModalidadesSemDuplicados.push('LI')
        } else {
            newModalidadesSemDuplicados = newModalidadesSemDuplicados.filter(item => item !== 'LI')
        }

        setModalidades(newModalidadesSemDuplicados)
    }



    const montaComponenteModalidades = (description, modality) => {


        let url = ''

        switch (modality) {
            case 'AC':
                url = 'https://sisu.furg.br/7-institucional/institucional/94-ampla-concorrencia';
                break;

            case 'V-PROAAF':
                url = 'https://sisu.furg.br/2016-04-26-18-00-54/2016-04-26-18-11-03/7-institucional/institucional/99-a1';
                break;

            case 'LI_EP':
                url = 'https://sisu.furg.br/matricula-e-documentacao/modalidades-de-ingresso/7-institucional/institucional/97-l3';
                break;

            case 'LI_PCD':
                url = 'https://sisu.furg.br/7-institucional/institucional/208-l13-candidatos-com-deficiencia-que-independentemente-da-renda-art-14-ii-portaria-normativa-n-18-2012-tenham-cursado-integralmente-o-ensino-medio-em-escolas-publicas-lei-n-12-711-2012';
                break;

            case 'LI_Q':
                url = 'https://sisu.furg.br/7-institucional/institucional/207-l14-candidatos-com-deficiencia-autodeclarados-pretos-pardos-ou-indigenas-que-independentemente-da-renda-art-14-ii-portaria-normativa-n-18-2012-tenham-cursado-integralmente-o-ensino-medio-em-escolas-publicas-lei-n-12-711-2012';
                break;

            case 'LI_PPI':
                url = 'https://sisu.furg.br/matricula-e-documentacao/modalidades-de-ingresso/7-institucional/institucional/98-l4';
                break;

            case 'LB_EP':
                url = 'https://sisu.furg.br/matricula-e-documentacao/modalidades-de-ingresso/7-institucional/institucional/95-l1';
                break;

            case 'LB_PCD':
                url = 'https://sisu.furg.br/7-institucional/institucional/210-l9-candidatos-com-deficiencia-que-tenham-renda-familiar-bruta-per-capita-igual-ou-inferior-a-1-5-salario-minimo-e-que-tenham-cursado-integralmente-o-ensino-medio-em-escolas-publicas-lei-n-12-711-2012';
                break;

            case 'LB_Q':
                url = 'https://sisu.furg.br/7-institucional/institucional/209-l10-candidatos-com-deficiencia-autodeclarados-pretos-pardos-ou-indigenas-que-tenham-renda-familiar-bruta-percapita-igual-ou-inferior-a-1-5-salario-minimo-e-que-tenham-cursado-integralmente-o-ensino-medio-em-escolas-publicas-lei-n-12-711-2012';
                break;

            case 'LB_PPI':
                url = 'https://sisu.furg.br/matricula-e-documentacao/modalidades-de-ingresso/7-institucional/institucional/96-l2';
                break;

            default:
                url = 'https://sisu.furg.br/matricula-e-documentacao/modalidades-de-ingresso';
                break;
        }



        return (
            <li className="d-flex justify-content-between text-secondary text-sd mt-1 list-group-item-custom ">{description}
                <a href={url} target="_blank" rel="noopener noreferrer">
                    <Link45deg size={22} color="var(--global-cor-info)" />
                </a>
            </li>
        )
    }

    const montaMsgAtencao = (action, msg) => {
        return (
            <div className="alert alert-warning mt-2" role="alert">
                <strong>{action}:</strong><p className="texto-formatado">{msg}</p>
            </div>
        )
    }


    return (
        <div className="card card-body w-100">
            <fieldset>
                <legend>Responda às 5 perguntas abaixo para verificar em qual cota você pode se inscrever!</legend>
                <hr className="hr" />

                <section className="form-radio required">
                    <label htmlFor="public_school_0">Você frequentou o Ensino Médio em uma escola pública por todo o período de três anos?</label>
                    <div className="d-flex flex-row">
                        <div className="form-check">
                            <input onChange={() => handleChangeModalities('EP', true)} type="radio" id="public_school_0" name="EP" value={1} />
                            <label htmlFor="public_school_0">Sim</label>
                        </div>
                        <div className="form-check">
                            <input onChange={() => handleChangeModalities('EP', false)} defaultChecked type="radio" id="public_school_1" name="EP" value={0} />
                            <label htmlFor="public_school_1">Não</label>
                        </div>
                    </div>
                </section>

                <section className="form-radio required">
                    <label htmlFor="with_lace_0">Deseja participar da modalidade de ingresso, considerando sua renda per capita igual ou inferior a 1 salário mínimo?</label>
                    <div className="d-flex flex-row">
                        <div className="form-check">
                            <input onChange={() => handleChangeModalities('LB', true)} type="radio" id="with_lace_0" name="LI_EP" value={1} />
                            <label htmlFor="with_lace_0">Sim</label>
                        </div>
                        <div className="form-check">
                            <input onChange={() => handleChangeModalities('LB', false)} defaultChecked type="radio" id="with_lace_1" name="LI_EP" value={0} />
                            <label htmlFor="with_lace_1">Não</label>
                        </div>
                    </div>
                    {modalidades.includes('LB') && montaMsgAtencao('Atenção', 'será obrigatória a apresentação do resumo do CadÚnico do candidato, contendo as informações do grupo familiar atualizada nos últimos 12 meses e que possua o valor da renda per capita inferior a R$ 1.518,00.')}
                </section>
                <section className="form-radio required">
                    <label htmlFor="disabled_person_0">Deseja participar da modalidade de ingresso como pessoa com deficiência?</label>
                    <div className="d-flex flex-row">
                        <div className="form-check">
                            <input onChange={() => handleChangeModalities('_PCD', true)} type="radio" id="disabled_person_0" name="_PCD" value={1} />
                            <label htmlFor="disabled_person_0">Sim</label>
                        </div>
                        <div className="form-check">
                            <input onChange={() => handleChangeModalities('_PCD', false)} defaultChecked type="radio" id="disabled_person_1" name="_PCD" value={0} />
                            <label htmlFor="disabled_person_1">Não</label>
                        </div>
                    </div>
                </section>

                <section className="form-radio required">
                    <label htmlFor="black_brown_indigenous_person">Deseja participar da modalidade de ingresso como autodeclarado preto, pardo e indígena?</label>
                    <div className="d-flex flex-row">
                        <div className="form-check">
                            <input onChange={() => handleChangeModalities('_PPI', true)} type="radio" id="black_brown_indigenous_person_0" name="_PPI" value={1} />
                            <label htmlFor="black_brown_indigenous_person_0">Sim</label>
                        </div>
                        <div className="form-check">
                            <input onChange={() => handleChangeModalities('_PPI', false)} defaultChecked type="radio" id="black_brown_indigenous_person_1" name="_PPI" value={0} />
                            <label htmlFor="black_brown_indigenous_person_1">Não</label>
                        </div>
                    </div>
                    {modalidades.includes('_PPI') && montaMsgAtencao('Observação', "Entende-se, por fenótipo negróide (incluindo pretos e pardos), conforme Instrução Normativa GAB/FURG N° 4/2023, o conjunto de características físicas do indivíduo, predominantemente, a cor da pele, a textura do cabelo e os aspectos faciais que, combinados ou não, permitirá a realização da análise da veracidade da autodeclaração. As cotas PPI de que tratam a LEI nº 14.723/2023, são reservadas para os candidatos com características negróides, excluídas as considerações sobre a ascendência. \n\n As vagas dessas modalidades exigem que o candidato seja submetido a comissão de heteroidentificação para comprovação da sua autodeclaração etnico-racial.")}
                </section>

                <section className="form-radio required">
                    <label htmlFor="quilombola_person">Deseja participar da modalidade de ingresso como autodeclarado quilombola?</label>
                    <div className="d-flex flex-row">
                        <div className="form-check">
                            <input onChange={() => handleChangeModalities('_Q', true)} type="radio" id="quilombola_person_0" name="_Q" value={1} />
                            <label htmlFor="quilombola_person_0">Sim</label>
                        </div>
                        <div className="form-check">
                            <input onChange={() => handleChangeModalities('_Q', false)} defaultChecked type="radio" id="quilombola_person_1" name="_Q" value={0} />
                            <label htmlFor="quilombola_person_1">Não</label>
                        </div>
                    </div>
                    {modalidades.includes('_Q') && montaMsgAtencao('Atenção', 'Será necessário comprovação da condição de candidato quilombola conforme as exigências do Edital do processo seletivo.')}
                </section>

                {modalidades &&
                    <section>
                        <hr className="hr" />
                        <label htmlFor="modalidades">Modalidade(s) em que você pode Concorrer.</label>
                        <ul className="list-group-custom">
                            {modalidades.includes('AC') && montaComponenteModalidades('Ampla concorrência', 'AC')}
                            {modalidades.includes('_PCD') && montaComponenteModalidades('V - PROAAF (candidatos com deficiência, sem comprovação de escola pública e sem comprovação de renda)', 'V-PROAAF')}

                            {modalidades.includes('EP') && modalidades.includes('LB') && <h3 className="mt-4 text-secondary text-sd">Lei de cotas - Escola Pública, Renda Inferior</h3>}
                            {modalidades.includes('EP') && modalidades.includes('LB') && montaComponenteModalidades('LB_EP (Escola Pública, Renda Inferior)', 'LB_EP')}
                            {modalidades.includes('EP') && modalidades.includes('LB') && modalidades.includes('_PPI') && montaComponenteModalidades('LB_PPI (Escola Pública, Renda Inferior, Preto, Pardo ou Indígena)', 'LB_PPI')}
                            {modalidades.includes('EP') && modalidades.includes('LB') && modalidades.includes('_PCD') && montaComponenteModalidades('LB_PCD (Escola Pública, Renda Inferior, Pessoa com Deficiência)', 'LB_PCD')}
                            {modalidades.includes('EP') && modalidades.includes('LB') && modalidades.includes('_Q') && montaComponenteModalidades('LB_Q (Escola Pública, Renda Inferior, Declarado(a) quilombola)', 'LB_Q')}
                            {modalidades.includes('EP') && modalidades.includes('LI') && <h3 className="mt-4 text-secondary text-sd">Lei de cotas - Escola Pública, Renda Não Considerada</h3>}
                            {modalidades.includes('EP') && modalidades.includes('LI') && montaComponenteModalidades('LI_EP (Escola Pública, Renda Não Considerada)', 'LI_EP')}
                            {modalidades.includes('EP') && modalidades.includes('LI') && modalidades.includes('_PPI') && montaComponenteModalidades('LI_PPI (Escola Pública, Renda Não Considerada, Preto, Pardo ou Indígena)', 'LI_PPI')}
                            {modalidades.includes('EP') && modalidades.includes('LI') && modalidades.includes('_PCD') && montaComponenteModalidades('LI_PCD (Escola Pública, Renda Não Considerada, Pessoa com Deficiência)', 'LI_PCD')}
                            {modalidades.includes('EP') && modalidades.includes('LI') && modalidades.includes('_Q') && montaComponenteModalidades('LI_Q (Escola Pública, Renda Não Considerada, Declarado(a) quilombola)', 'LI_Q')}
                        </ul>
                    </section>
                }
            </fieldset>
        </div>
    )
}

export default CalculadoraModalidades;